import FacebookSvg from "@/public/FacebookMark1.svg";
import InstagramSvg from "@/public/InstagramMark1.svg";
import TwitterSvg from "@/public/TwitterMark1.svg";
import { PortableTextBlock } from "@sanity/types";
import SMaxWidthContainer from "components/framework/SMaxWidthContainer";
import RichText from "components/richtext/RichText";
import PublicRuntimeConfig from "lib/types/PublicRuntimeConfig";
import { ICommonAppData } from "lib/types/sanity";
import { ISoMeLink } from "lib/types/Settings";
import getConfig from "next/config";
import Link from "next/link";
import styles from "./Footer.module.css";

const { publicRuntimeConfig } = getConfig() as { publicRuntimeConfig: PublicRuntimeConfig };

//#region [Props]
type FooterProps = {
    appData: ICommonAppData;
}
//#endregion

//#region [Component]
export default function Footer({ appData }: FooterProps) {
    if (!appData?.footer) {
        return null;
    }
    return <footer className={styles.Footer}>
        <SMaxWidthContainer className={styles.FooterContent}>

            <FooterColumn col={appData.footer.col1} />

            <FooterColumn col={appData.footer.col2} />

            <FooterColumn col={appData.footer.col3} />

            {(appData.settings?.footer_some_links?.length ?? 0) > 0 && <div className={styles.SoMeLinks}>
                {appData.settings.footer_some_links!.map(someLink => <SoMeLink key={someLink._key} link={someLink} />)}
            </div>}
            <div className={styles.CenteredContent}>Nettsiden er utviklet av Filmweb. Vi følger retningslinjer for <Link href={publicRuntimeConfig.NEXT_PUBLIC_FILMWEB_PRIVACYPOLICY_URL} legacyBehavior><a target="_blank">personvern og bruker cookies.</a></Link></div>

        </SMaxWidthContainer>
    </footer>
}
//#endregion

//#region [Props]
type FooterColumnProps = {
    col: PortableTextBlock[]
}
//#endregion


//#region [Component]
function FooterColumn({ col }: FooterColumnProps) {
    if (!col) {
        return null;
    }
    return <section className={styles.FooterColumn}>
        <RichText value={col} />
    </section>
}
//#endregion


//#region [Props]
type SoMeLinkProps = {
    link: ISoMeLink;
}
//#endregion

const iconsMap: Record<string, JSX.Element> = {
    "facebook": <FacebookSvg />,
    "twitter": <TwitterSvg />,
    "instagram": <InstagramSvg />
};

//#region [Component]
function SoMeLink({ link }: SoMeLinkProps) {
    return <Link href={link.url} passHref legacyBehavior><a className={styles.SoMeLink} target="_blank" aria-label={link._type}>{iconsMap[link._type]}</a></Link>
}
//#endregion